import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosPost from "../axios/axios-post";
import axiosGet from "../axios/axios-get";

const BASE_URL = "/about";

export const AboutAPI = Object.freeze({
  get: createAsyncThunk("get/about", async (_, { rejectWithValue }) => {
    try {
      const response = await axiosGet.get(BASE_URL);
      
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }),

  create: createAsyncThunk(
    "post/post-about",
    async (data, { rejectWithValue }) => {
      try {
        const response = await axiosPost.post(BASE_URL, data);

        return response.data;
      } catch (error) {
        return rejectWithValue(error.response?.data || error.message);
      }
    }
  ),
});
